import { render, staticRenderFns } from "./TipoTarefaForm.vue?vue&type=template&id=0694be8f"
import script from "./TipoTarefaForm.vue?vue&type=script&lang=js"
export * from "./TipoTarefaForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports